module.exports = __webpack_public_path__ + "static/media/home-slider-3.d2b63ddb.jpg";